

const svgDesigns = {
    width: "50px"
}
export default svgDesigns;